import React, { useState, useEffect } from 'react';
import Sidebar from './components/Sidebar'
import EditBrandForm from './EditBrandForm'
import api from '../api'

const BrandForm = () => {
  const [brandName, setBrandName] = useState('');
  const [brandList, setBrandList] = useState([]);
  const [loading, setLoading] = useState(false);

  // const URL = import.meta.env.VITE_BASE_URL;

  const handleBrandSubmit = async () => {
    try {
      const response = await api.post('/brands', { name: brandName });

      const brand = response.data;
      setBrandName('');
      alert('New portfolio successfully created');
      console.log('Portfolio title created:', brand);

      // Refresh the page after successful submission
      window.location.reload();
    } catch (error) {
      console.error('Error creating portfolio title:', error.response?.data || error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch data from the backend
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await api.get('/brands');
      setBrandList(response.data);
    } catch (error) {
      console.error('Error fetching data:', error.response?.data || error.message);
    }
  };

  const handleBrandUpdated = (updatedBrand) => {
    const updatedBrands = brandList.map((brand) => (brand._id === updatedBrand._id ? updatedBrand : brand));
    setBrandList(updatedBrands);
  };

  const handleDeleteBrand = async (brandId) => {
    try {
      await api.delete(`/brands/${brandId}`);
      setBrandList(brandList.filter((brand) => brand._id !== brandId));
    } catch (error) {
      console.error('Error deleting portfolio title:', error.response?.data || error.message);
    }
  };



  return (
    <div className="flex min-h-screen bg-gray-50" style={{ fontFamily: "Muli" }}>
      <Sidebar />
      <div className="w-full">
        {/* Top bar */}
        <div className="sticky top-0 z-10 flex items-center justify-between border-b border-gray-200 bg-white/80 backdrop-blur px-6 py-4">
          <p className="text-sm font-medium text-gray-400">Admin Dashboard</p>
          <span className="text-sm font-semibold text-gray-700">Welcome, Admin</span>
        </div>

        <div className="mx-auto max-w-5xl px-6 py-8">
          {/* Page heading */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">Portfolio Titles</h1>
            <p className="mt-1 text-sm text-gray-500">Create and manage the portfolio categories used across the site.</p>
          </div>

          {/* Create card */}
          <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
            <label className="block text-sm font-semibold text-gray-700 mb-2">New portfolio title</label>
            <div className="flex flex-col gap-3 sm:flex-row">
              <input
                className="flex-1 rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-gray-900 focus:ring-2 focus:ring-gray-900/10"
                type="text"
                placeholder="e.g. Threads of Light"
                value={brandName}
                onChange={(e) => setBrandName(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleBrandSubmit()}
              />
              <button
                className="inline-flex items-center justify-center rounded-xl bg-gray-900 px-8 py-3 text-sm font-semibold uppercase tracking-wide text-white transition hover:bg-black disabled:cursor-not-allowed disabled:opacity-50"
                onClick={handleBrandSubmit}
                disabled={loading || !brandName.trim()}
              >
                {loading ? 'Creating...' : 'Create'}
              </button>
            </div>
          </div>

          {/* Portfolio list */}
          <div className="mt-10">
            <h2 className="mb-4 text-xl font-bold text-gray-900">
              List of portfolios <span className="text-base font-medium text-gray-400">({brandList.length})</span>
            </h2>
            <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">S/N</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Portfolio</th>
                      <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Edit</th>
                      <th className="px-6 py-3 text-right text-xs font-semibold uppercase tracking-wider text-gray-500">Action</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100 bg-white">
                    {brandList.length === 0 ? (
                      <tr>
                        <td colSpan={4} className="px-6 py-12 text-center text-sm text-gray-400">
                          No portfolios created yet.
                        </td>
                      </tr>
                    ) : (
                      brandList.map((brand, index) => (
                        <tr className="transition hover:bg-gray-50" key={brand._id}>
                          <td className="px-6 py-4 text-sm text-gray-500">{index + 1}</td>
                          <td className="px-6 py-4 text-sm font-medium capitalize text-gray-900">{brand.name}</td>
                          <td className="px-6 py-4">
                            <EditBrandForm brandId={brand._id} onBrandUpdated={handleBrandUpdated} />
                          </td>
                          <td className="px-6 py-4 text-right">
                            <button
                              className="rounded-lg bg-red-50 px-4 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-500 hover:text-white"
                              onClick={() => handleDeleteBrand(brand._id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandForm;
